import {Box, Typography} from '@mui/material';
import styles from '../../../styles/components/clientdetails/projectDrawerStyle.module.scss';

type ProjectSectionHeaderProps = {
  headerText: string;
  containerClass?: string;
  typographyClass?: string;
};

function ProjectSectionHeader({
  headerText,
  containerClass = '',
  typographyClass = '',
}: ProjectSectionHeaderProps) {
  return (
    <Box className={`${styles.projectDrawerSectionHeader} ${containerClass}`}>
      <Typography
        className={`${styles.projectDrawerSectionHeaderText} ${typographyClass}`}
      >
        {headerText}
      </Typography>
    </Box>
  );
}

export default ProjectSectionHeader;
